import { Component, OnInit } from '@angular/core';
import { formatDate, PlatformLocation  } from '@angular/common';
import {Router} from "@angular/router"
import { DataService } from 'src/app/services';
import { Base64 } from 'js-base64';
import { FlightRouteContent, loadFlightRoutes } from '../../seo/flight-route.model';

const POPULAR_SLUGS = [
  'nairobi-to-mombasa', 'nairobi-to-kisumu', 'nairobi-to-eldoret', 'nairobi-to-diani',
  'nairobi-to-kampala', 'nairobi-to-zanzibar', 'nairobi-to-dubai', 'nairobi-to-london'
];

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  popularRoutes: FlightRouteContent[] = [];

  constructor(
    private router:Router,
    private dataService: DataService
  ) { }

  ngOnInit() {
    loadFlightRoutes().then(routes => {
      this.popularRoutes = POPULAR_SLUGS
        .map(slug => routes.find(route => route.slug === slug))
        .filter((route): route is FlightRouteContent => !!route);
    });
  }


  clickNairobiTl(){
    var traveldate = formatDate(new Date(),"yyyy-MM-dd","en-KE");

    let formdata={
      'pickup' : 'Nairobi',
      'dropoff' : 'Kitale',
      'pickupname' : 'Nairobi',
      'dropoffname' : 'Kitale',
      'traveldate' :  traveldate,
      'returndate': '',
      'returning' : false
    }

    this.getTopRoutes(formdata, 'Nairobi', 'Kitale', traveldate)


  }

  clickNairobiMb(){
    var traveldate = formatDate(new Date(),"yyyy-MM-dd","en-KE");

    let formdata={
      'pickup' : 'Nairobi',
      'dropoff' : 'Malaba',
      'pickupname' : 'Nairobi',
      'dropoffname' : 'Malaba',
      'traveldate' :  traveldate,
      'returndate': '',
      'returning' : false
    }

    this.getTopRoutes(formdata, 'Nairobi', 'Malaba', traveldate)

  }

  clickNairobiBg(){
    var traveldate = formatDate(new Date(),"yyyy-MM-dd","en-KE");

    let formdata={
      'pickup' : 'Nairobi',
      'dropoff' : 'Bungoma',
      'pickupname' : 'Nairobi',
      'dropoffname' : 'Bungoma',
      'traveldate' :  traveldate,
      'returndate': '',
      'returning' : false
    }

    this.getTopRoutes(formdata, 'Nairobi', 'Bungoma', traveldate)
  }

  getTopRoutes(sdata, fromCity?: string, toCity?: string, onward?: string){
    let p=Base64.encode(JSON.stringify(sdata));
    this.dataService.changeMessage(p);
    if (fromCity && toCity) {
      const routeSlug = `${fromCity}-to-${toCity}`;
      const queryParams: any = { fromCityName: fromCity, toCityName: toCity };
      if (onward) { queryParams['onward'] = onward; }
      this.router.navigate(['/booking', routeSlug], { queryParams });
    } else {
      this.router.navigate(['/booking']);
    }
  }

}
